// @ts-nocheck
import { Column } from "react-table";
import { DateRequestCell } from "./DateRequestCell";
import { CustomHeader } from "./CustomHeader";
import { AmountCurrencyCell } from "./AmountCurrencyCell";
import { IDefaultCustomColumn } from "../../../transaction-history/transaction-history-list/core/_models";
import Action from "./Action";

// TOO FILTER
// const TRANSACTION_HISTORY_LOCAL_STORAGE_KEY =
//   "disbursement-default-custom-column";
// const lsValue = localStorage.getItem(TRANSACTION_HISTORY_LOCAL_STORAGE_KEY);
// const customColumn = !!JSON.parse(lsValue)
//   ? JSON.parse(lsValue)
//   : IDefaultCustomColumn;
// const convertToArray = Object.keys(customColumn).filter(function (x) {
//   return customColumn[x] !== false;
// });

const Columns: ReadonlyArray<Column<any>> = [
  {
    Header: (props) => (
      <CustomHeader
        tableProps={props}
        title="User Info"
        className="min-w-200px"
      />
    ),
    id: "userInfo",
    Cell: ({ ...props }) => {
      const user = props.data[props.row.index];
      return (
        <div className="d-flex align-items-center">
          <div className="symbol symbol-40px symbol-circle me-3">
            <div className="symbol-label bg-primary text-white fw-bold fs-7">
              {user.fullName ? user.fullName.charAt(0).toUpperCase() : 'U'}
            </div>
          </div>
          <div className="d-flex flex-column">
            <div className="text-gray-800 fw-bold mb-1">{user.fullName || 'N/A'}</div>
            <div className="text-muted fs-7">@{user.userName || 'N/A'}</div>
          </div>
        </div>
      );
    },
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title="Email" className="min-w-200px ps-4" />
    ),
    id: "email",
    Cell: ({ ...props }) => {
      const email = props.data[props.row.index].email;
      return (
        <div className="d-flex align-items-center ps-4">
          <span className="text-gray-800">{email || 'No email'}</span>
        </div>
      );
    },
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title="Role" className="min-w-175px ps-4" />
    ),
    id: "role",
    Cell: ({ ...props }) => {
      const role = props.data[props.row.index].role;
      const getRoleColor = (role: string) => {
        // All roles use warning color
        return 'warning';
      };
      const getRoleDisplay = (role: string) => {
        return role?.replace(/_/g, ' ') || 'No Role';
      };
      return (
        <div className="ps-4">
          <span className={`badge badge-light-${getRoleColor(role)} fw-bold px-3 py-2 fs-7`}>
            {getRoleDisplay(role)}
          </span>
        </div>
      );
    },
  },
  {
    Header: (props) => (
      <CustomHeader
        tableProps={props}
        title="User Status"
        className="min-w-125px ps-4"
      />
    ),
    Cell: ({ ...props }) => (
      <div className="ps-4">
        {props.data[props.row.index].isActive ? (
          <span className="badge rounded-pill bg-success">Active</span>
        ) : (
          <span className="badge rounded-pill bg-secondary">Inactive</span>
        )}
      </div>
    ),
    id: "status",
    accessor: "isActive",
  },
  {
    Header: (props) => (
      <CustomHeader
        tableProps={props}
        title="Created"
        className="min-w-150px ps-4"
      />
    ),
    id: "createdAt",
    Cell: ({ ...props }) => (
      <div className="d-flex flex-column ps-4">
        <DateRequestCell createdAt={props.data[props.row.index].createdAt} />
      </div>
    ),
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title="Actions" className="min-w-150px text-end pe-4" />
    ),
    Cell: ({ ...props }) => {
      const row = props.row.original;
      return (
        <div className="text-end pe-4">
          <Action row={row} />
        </div>
      );
    },
    id: "action",
  },
];

export { Columns };
